<template>
  <div
    class="factory-recommend"
    v-if="list && list.length > 0"
  >
    <div class="factory-recommend__header">
      <p class="factory-recommend__title">
        Factory's Popular Products
      </p>
      <p
        class="factory-recommend__more"
        @click="onViewAll"
      >
        View all
      </p>
    </div>
    <div class="factory-recommend__content">
      <FactoryProductItem
        v-for="item of list"
        :key="item.offerId"
        :item="item"
        @click="onItemClick(item)"
      />
    </div>
  </div>
</template>

<script setup>
import { useQuery } from '@tanstack/vue-query'
import { retrieveFactoryTopProduct } from '@/api/factory'
import { formatName, openURLWithChannelQuery, buriedPointUtil } from '@/utils/utils'
import FactoryProductItem from '@/views/Factory/components/FactoryProductItem.vue'

const props = defineProps({
  factoryId: {
    type: String,
    required: true
  }
})
const factoryId = computed(() => props.factoryId)

const router = useRouter()

const { data: list } = useQuery({
  queryKey: ['/appb/alibaba-common/supplier/product/top', factoryId.value],
  queryFn: () => retrieveFactoryTopProduct({
    sellerOpenId: factoryId.value,
    topN: 8
  }),
  enabled: computed(() => factoryId.value !== null),
  refetchOnWindowFocus: false
})
const supplierName = computed(() => list.value[0]?.supplierName ?? '-')

const onViewAll = () => {
  buriedPointUtil({ eventId: 'PPD212', others: { location: 'Detail' } })
  router.push({
    name: 'factory',
    params: {
      name: formatName(supplierName.value),
      id: factoryId.value
    }
  })
}

const onItemClick = (item) => {
  buriedPointUtil({ eventId: 'PPD204', others: { location: 'Detail' } })

  const { href } = router.resolve({
    name: 'offer',
    params: {
      id: item.offerId
    },
    query: {
      key: btoa(item.monthSold)
    }
  })
  openURLWithChannelQuery(href)
}
</script>

<style lang="less" scoped>
.factory-recommend {
  padding-top: 32px;
  padding-bottom: 32px;
  border-top: 1px solid #EBF1F5;

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__title {
    font-family: mon-700;
    font-size: 18px;
    line-height: 24px;
    color: #232323;
  }

  &__more {
    font-family: mon-600;
    font-size: 11px;
    line-height: 14px;
    color: #232323;
    text-decoration: underline;
    cursor: pointer;
    transition: all .2s ease-in-out;

    &:hover {
      color: #004F9A;
    }
  }

  &__content {
    margin-top: 20px;
    margin-bottom: 40px;
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 16px;

    .factory-product-item:nth-child(6),
    .factory-product-item:nth-child(7),
    .factory-product-item:nth-child(8) {
      display: none;
    }

    @media (min-width: 1536px) {
      grid-template-columns: repeat(6, 1fr);
      .factory-product-item:nth-child(6) {
        display: block;
      }
    }

    @media (min-width: 1680px) {
      grid-template-columns: repeat(7, 1fr);
      .factory-product-item:nth-child(7) {
        display: block;
      }
    }

    @media (min-width: 1920px) {
      grid-template-columns: repeat(8, 1fr);
      .factory-product-item:nth-child(8) {
        display: block;
      }
    }
  }
}
</style>
